import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { useHistory, useLocation } from 'react-router-dom'

import { submitMissingIntegration, createMissingIntegrationSuggestion } from "../api/searchIntegrations";
import {changeOptionSidePanel, sidePanelOption} from "../slices/optionsSlice";

import
{
    MISSING_INTEGRATION_TYPE,
    SUBMIT_RESULT_TYPE,
    EMAIL_INVALID,
    emailRegexp,
    REQUIRED,
    siteRegexp,
    URL_INVALID,
    GOALS_DESCRIPTION,
    GOALS_SIDEPANEL,
    MISSING_INTEGRATION_DESCRIPTION,
    MISSING_INTEGRATION_DESCRIPTION_SUBMIT,
    DESCRIPTION_TYPE
} from './Constants';
import {ReactComponent as ArrowBackIcon} from "../assets/info_arrow.svg";


const TextInput = ({ label, id, errors, touched, values, ...props }) => {
    const error = errors[id];
    const touch = touched[id];
    const value = values[id];

    return (
        <div className="side-panel-panel-input-container">
            <label htmlFor={id || props.name}>{label}</label>
            <input className={`side-panel-panel-input ${touch && error ? "side-panel-panel-input-error-input" : ""}`} value={value} id={id} {...props} />
            {touch && error ? (
                <div className="side-panel-panel-input-error">{error}</div>
            ) : null}
        </div>
    );
};

const Title = ({title, type, description, closePanel}) => {

    const titleDescription = type === MISSING_INTEGRATION_TYPE ? MISSING_INTEGRATION_DESCRIPTION : MISSING_INTEGRATION_DESCRIPTION_SUBMIT;

    const submitResultForm = SUBMIT_RESULT_TYPE === type;
    
    return <div className={"success-submit " + (submitResultForm ? 'thank-you-component' : '')}>
        <div className={'success-submit-header-container'}>
            {type === 'type-submit-result' || <ArrowBackIcon className="side-panel-arrow-back" style={{fill: "transparent", stroke: "#5A5A5A"}} onClick={closePanel}/>}
            <div className="success-submit-header">{title}</div>
        </div>
        
        <div className="success-submit-description">{titleDescription}</div>

    </div>
}

const rightToLeftLayoutStubs = new Set(['customer_analytics', 'marketing_analytics', 'personalise']);

const GoalContent = ({stub, closePanel}) => {
    const location = useLocation();
    let currentStub = '';
 
    if(stub !== undefined) {
        currentStub = stub;
    } else if(location.pathname.substring(1) !== '' ) {
        currentStub = location.pathname.substring(1);
    }
    else {
        return false;
    }
            
   const {title, description, color_1, color_2, image, arrow_color, title_color, description_color} = GOALS_SIDEPANEL[0][currentStub];
          

    const rightToLeftLayout = rightToLeftLayoutStubs.has(currentStub);
    const isMarketingAnalytics = currentStub === 'marketing_analytics';
    
    return <div className={'main-side-panel ' + currentStub + `${rightToLeftLayout ? ' right-to-left' : ''}`} style={{
        background: (rightToLeftLayout ? `url("${image}") no-repeat right bottom,` : '') + ` -webkit-linear-gradient(top, ${color_1} 50%,${color_2} 50%)`,
        backgroundSize: isMarketingAnalytics ? '360px' : '100% cover'
    }}>
         <div className={'arrow-panel-section'}>
             <ArrowBackIcon className="side-panel-arrow-back" style={{fill: "transparent", stroke: arrow_color}} onClick={closePanel} />
         </div>

         <div className={'right-container'}>
             <div className="side-panel-panel-title-header" style={{color: title_color}} >{title}</div>
             <div className={'description-and-image-container ' + (rightToLeftLayout ? 'right-to-left' : '')}>
                 <div className="side-panel-panel-title-description" style={{color: description_color}}>{description}</div>
                 {rightToLeftLayout ? null : <div className={"image-block"}><img src={image} alt={currentStub} /></div>}
             </div>
         </div>
         
     </div>

}

const SidePanel = () => {
    const sidePanel = useSelector(state => state.options.options.sidePanel);
    const dispatch = useDispatch();
    const isPanelOpened = sidePanel.openedBefore ? `side-panel-panel-${sidePanel.isOpen ? "on" : "off"}` : "side-panel-panel-never-opened";
    const history = useHistory();

    React.useEffect(() => {
        if (isPanelOpened) {
            window.addEventListener("keydown", e => (e.code === "Escape" ? closePanel() : null))
        }
    }, [isPanelOpened])

    const formik = useFormik({
        initialValues: {
            integrationName: "",
            integrationWebsite: "",
            other: "",
            firstName: "",
            lastName: "",
            email: ""
        },
        onSubmit: (values) => {
            submitMissingIntegration(createMissingIntegrationSuggestion(values.integrationName, values.integrationWebsite,
                values.other, values.firstName, values.lastName, values.email), (submissionResult) => {
                dispatch(changeOptionSidePanel(sidePanelOption(true, SUBMIT_RESULT_TYPE, "Thank you")));
                distil.trackEvent('integration_missing_form_submitted', ' ', {submissionId: submissionResult.id});
            })
        },
        validate: (values) => {
            const errors = {}
            if (!values.integrationName) {
                errors.integrationName = REQUIRED;
            }
            if (!values.integrationWebsite) {
                errors.integrationWebsite = REQUIRED;
            } else if (!siteRegexp.test(values.integrationWebsite)) {
                errors.integrationWebsite = URL_INVALID;
            }
            if (values.email && !emailRegexp.test(values.email)) {
                errors.email = EMAIL_INVALID;
            }
            return errors;
        }
    })
    
    const closePanel = () => {
        formik.resetForm()
        history.push('/');
        dispatch(changeOptionSidePanel(sidePanelOption(false, "", "")));
        window.removeEventListener("keydown", e => {e.code === "Escape" ? closePanel() : null})
    }

    const isDescription = sidePanel.type === DESCRIPTION_TYPE;
    
    return <div className={`side-panel side-panel-${sidePanel.isOpen ? "on" : "off"}`} onClick={closePanel}>
        <div className={`side-panel-panel ${isPanelOpened}`} onClick={(e) => e.stopPropagation()} >
            <GoalContent stub={sidePanel.stub} closePanel={closePanel}/>
            <div className="side-panel-panel-main">

                {!isDescription && <Title title={sidePanel.title} type={sidePanel.type} description={sidePanel.description} closePanel={closePanel}/>}


                {sidePanel.type === MISSING_INTEGRATION_TYPE &&
                    <React.Fragment>
                        <br/>
                        <form onSubmit={formik.handleSubmit}>
                            <TextInput label="Integration Name (*)"
                                       id="integrationName"
                                       name="integrationName"
                                       errors={formik.errors}
                                       touched={formik.touched}
                                       onBlur={formik.handleBlur}
                                       onChange={formik.handleChange}
                                       values={formik.values}/>
                            <br/>
                            <TextInput label="Integration Website Url (*)"
                                       id="integrationWebsite"
                                       name="integrationWebsite"
                                       errors={formik.errors}
                                       touched={formik.touched}
                                       onBlur={formik.handleBlur}
                                       onChange={formik.handleChange}
                                       values={formik.values} placeholder="zapier.com"/>
                            <br/>
                            <TextInput label="Other information"
                                       id="other"
                                       name="other"
                                       errors={formik.errors}
                                       touched={formik.touched}
                                       onBlur={formik.handleBlur}
                                       onChange={formik.handleChange}
                                       values={formik.values}/>
                            <div className="side-panel-panel-border"/>
                            <div className="side-panel-panel-input-container">
                                Your Contact (Optional)
                            </div>
                            <div className="description">
                                If you would like us to follow up with you about this Integration please complete your details below
                            </div>
                            <div className="side-panel-panel-input-container-combined">
                                <TextInput label="First Name"
                                           id="firstName"
                                           name="firstName"
                                           errors={formik.errors}
                                           touched={formik.touched}
                                           onBlur={formik.handleBlur}
                                           onChange={formik.handleChange}
                                           values={formik.values}/>
                                <TextInput label="Last name"
                                           id="lastName"
                                           name="lastName"
                                           errors={formik.errors}
                                           touched={formik.touched}
                                           onBlur={formik.handleBlur}
                                           onChange={formik.handleChange}
                                           values={formik.values}/>
                                <TextInput label="Email address"
                                           id="email"
                                           name="email"
                                           errors={formik.errors}
                                           touched={formik.touched}
                                           onBlur={formik.handleBlur}
                                           onChange={formik.handleChange}
                                           values={formik.values}/>
                            </div>
                            <button className="side-panel-panel-submit">
                                Submit
                            </button>
                        </form>
                    </React.Fragment>
                }
                {sidePanel.type === SUBMIT_RESULT_TYPE &&
                    <React.Fragment>
                        <div onClick={closePanel} className="side-panel-panel-close">
                            Close
                        </div>
                    </React.Fragment>
                }
            </div>
        </div>
    </div>
}

export default SidePanel;
